import { AD_TYPES, ALGORITHM_OPTIONS } from "components/core/blocks/AdPlan/constants";
import { AlgoSlider } from "components/core/blocks/AdPlan/AdvancedTargetingOptions";
import { Flex, Wrap } from "../../../styled-system/jsx";
import { css } from "../../../styled-system/css";
import { Select } from "components/fields/base/Select";
import { useAppSelector } from "redux/hooks";

interface BulkAlgoFormData {
  algorithm: string;
  salesVolumeControl: number;
  adType: number;
}

type Props = {
  formData: BulkAlgoFormData;
  setFormData: (data: BulkAlgoFormData) => void;
};

const BulkAdPlanAlgoForm = ({ formData, setFormData }: Props) => {
  const { currentChannel } = useAppSelector((state) => state.channel);
  const adTypeOptions = [
    AD_TYPES.SPONSORED_PRODUCT,
    AD_TYPES.SPONSORED_PRODUCT_AUTO,
    AD_TYPES.SPONSORED_BRAND_V2,
    AD_TYPES.SPONSORED_DISPLAY_V2,
  ];

  const algoOptions = [ALGORITHM_OPTIONS.ROAS_BOOST, ALGORITHM_OPTIONS.GROWTH_MAX, ALGORITHM_OPTIONS.RULES_ENGINE_ONLY];

  const onChange = (key: string, value: number | string | null) => {
    const updatedFormData = { ...formData, [key]: value };
    setFormData(updatedFormData);
  };

  if (
    [AD_TYPES.SPONSORED_PRODUCT.value, AD_TYPES.SPONSORED_PRODUCT_AUTO.value].includes(formData.adType) &&
    currentChannel === "amazon"
  ) {
    algoOptions.push(ALGORITHM_OPTIONS.PLACEMENT_MAX);
  } else {
    algoOptions.filter((o) => o.value !== ALGORITHM_OPTIONS.PLACEMENT_MAX.value);
    if (formData.algorithm === ALGORITHM_OPTIONS.PLACEMENT_MAX.value) {
      onChange("algorithm", ALGORITHM_OPTIONS.GROWTH_MAX.value);
    }
  }

  return (
    <form
      onSubmit={(e) => e.preventDefault()}
      className={css({ display: "flex", flexDirection: "column", alignItems: "center" })}
    >
      <p className={css({ padding: "large", textAlign: "center" })}>
        Update the bidding algorithm for the selected media plans.
      </p>
      <Wrap gap="large" width="100%">
        <Select
          label={"Media Plan Type"}
          onSelectionChange={(value) => {
            onChange("adType", value as number);
          }}
          selectedKey={formData.adType}
          items={adTypeOptions}
        />
        <Select
          label={"Algorithm"}
          onSelectionChange={(value) => {
            onChange("algorithm", value as string);
          }}
          selectedKey={formData.algorithm}
          items={algoOptions}
        />
      </Wrap>

      {formData.algorithm === ALGORITHM_OPTIONS.GROWTH_MAX.value ?
        <Flex className={css({ width: "100%", margin: "auto", paddingTop: "medium" })} justifyContent="center">
          <AlgoSlider
            aria-labelledby="discrete-slider-always"
            step={1}
            min={0}
            max={9}
            ThumbComponent={"div"}
            marks={[
              { value: 0, label: "Increase Margin" },
              { value: 1, label: "Optimal Profit" },
              { value: 2 },
              { value: 3 },
              { value: 4 },
              { value: 5 },
              { value: 6 },
              { value: 7 },
              { value: 8 },
              { value: 9, label: "Max Volume" },
            ]}
            defaultValue={formData.salesVolumeControl}
            valueLabelDisplay="off"
            onChange={(_, value) => {
              onChange("salesVolumeControl", value as number);
            }}
          />
        </Flex>
      : null}
    </form>
  );
};

export default BulkAdPlanAlgoForm;
